<template>
    <div id="service-portal">
        <div class="row">
            <div class="col-sm-12">
                <h1>{{ $t("headline") }}</h1>
                <p class=""><span class="headline h3">{{ $t("search_info") }}</span></p>
                <div class="row">
                    <div class="col-sm-8">
                        <visual-token-search
                                :resultConfig="autocompleteResultTypes"
                                @submit="getResults"
                                v-model="search"
                                :query="query"
                        ></visual-token-search>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="service-selection">
                    <service-list></service-list>
                </div>

                <div class="service-content" id="service-content">
                    <router-view></router-view>
                    <a href="#service-content" id="back-to-service-content" ref="backToTop"><i
                            class="icon si-arrow-down"
                    ></i></a>
                </div>
            </div>
        </div>

        <div class="hidden">
            <youtube></youtube>
        </div>
    </div>
</template>

<script>
    import ServiceList from './components/ServiceList.vue'
    import ServiceDownloads from './components/ServiceDownloads'
    import ServiceVideos from "./components/ServiceVideos";
    import ServiceFaq from "./components/ServiceFaq";
    import ServiceDownloadsResults from "./components/ServiceDownloadsResults";
    import Loader from "./components/Loader";
    import VisualTokenSearch from "./components/VisualTokenSearch";
    import DropdownDocumentResult from "./components/DropdownDocumentResult";
    import DropdownTextResult from "./components/DropdownTextResult";
    import {Youtube} from 'vue-youtube';
    import {mapState} from "vuex";

    const Results = {
        'downloads': ServiceDownloadsResults,
        'videos': ServiceVideos,
        'faq': ServiceFaq
    };

    const autocompleteResultTypes = {
        'default': DropdownTextResult,
        'downloads': DropdownDocumentResult,
        'videos': DropdownDocumentResult
    };

    export default {
        name: 'service-portal',
        components: {
            ServiceList,
            VisualTokenSearch,
            Youtube
        },

        created() {
            this.$store.commit('setLanguage', window.locale);
            this.$store.dispatch('fetchCategories');
            this.$store.dispatch('fetchCategoriesMap');
        },
        mounted() {
            let self = this;
            if (this.$refs['backToTop']) {

                this.$nextTick(function () {
                    jQuery(self.$refs['backToTop']).affix({offset: {top: 300}});
                })
            }
        },
        computed: {
            ...mapState({
                category: state => state.search.category,
                query: state => state.search.query
            }),
            results() {
                if (this.$store.state.results == null) {
                    return null;
                }

                return Results[this.$store.state.results];
            }
        },
        watch: {},
        methods: {
            getResults(e) {
                this.$store.commit('selectService', null);

                this.$router.push({
                    name: 'search',
                    params: {},
                    query: {
                        query: this.search,
                        category: this.category
                    }
                });
                this.$store.commit('setSearchQuery', this.search);
                this.$store.dispatch('getResults');
            }
        },
        data: function () {
            return {
                search: null,
                autocompleteResultTypes: autocompleteResultTypes,
            }
        }
    }
</script>

<style lang="less">
  .si-arrow-down {
    transform: rotate(180deg);
  }

  #back-to-service-content {
    line-height: 26px;
    border: 1px solid #ccc;
    padding: 0 8px;
    position: absolute;
    right: 30px;
    top: 100vh;
    opacity: 0;
    transition: opacity 0.5s ease;
    background-color: #fff;
    z-index: 1;

    &.affix {
      position: fixed;
      top: auto;
      bottom: 0;
      opacity: 1;
    }

    .affix-top {
    }

    .affix-bottom {
    }
  }

  .vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
  }

  .vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0, 0, 0, 0);
    transform: rotate3d(0, 0, 0, 0);
    -webkit-transition: background-color 100ms ease-out,
    margin 100ms ease-out,
    height 100ms ease-out;
    transition: background-color 100ms ease-out,
    margin 100ms ease-out,
    height 100ms ease-out;
    background-color: rgba(48, 121, 244, .4);
    margin: 5px 5px 5px 0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
  }

  .vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .4);
  }

  .vb:hover > .vb-dragger > .vb-dragger-styler,
  .vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
  }


  .tokenizer {
    position: relative;
    display: flex;
    flex-direction: row;
    flex: 1 1 0px;
    min-width: 0px;
    flex-wrap: wrap;
    align-items: flex-start;
    align-self: flex-start;
    min-height: 32px;
    padding: 8px 5px 0 5px;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
    font-family: Regular, helvetica neue, helvetica, Arial, sans-serif;
    border-radius: 3px;
    border-right: none;
    color: #4e515e;
    overflow: hidden;
    word-wrap: break-word;

    .no-animation {
      transition: none !important;
    }

    .separator {
      display: inline-block;
      height: 24px;
      padding: 8px 4px 0px 4px;
      margin: -4px 0 0px 0;
      transition: transform 0.2s ease-out;
      cursor: text;
      border-bottom: 2px solid transparent;

      &:not(.bk-edited-node):hover {
        //background-image: url(../resources/img/fill-dots-gray5.png);
      }

      &.bk-edited-node {
        height: 20px;
        transform: translate3d(8px, 0, 0);
        transition: transform 0.2s ease-in;
      }

      &.bk-edited-node ~ .token {
        transform: translate3d(16px, 0, 0);
        transition: transform 0.2s ease-in;
      }


      &.bk-edited-node ~ .separator {
        transform: translate3d(16px, 0, 0);
        transition: transform 0.2s ease-in;
      }

      &.bk-edited-node:not(:empty) {
        border-bottom: 2px dotted #BFBFBF;
        border-radius: 2px;
      }
    }

    .init-token {
      position: relative;
      background-color: transparent;
      padding-left: 4px;
      padding-right: 4px;
      padding-top: 4px;

      &:hover {
        border-bottom: inherit;
      }

      &:not(:empty) {
        border-bottom: 2px dotted #333333;
      }
    }

    .token {
      display: inline-block;
      background-color: #ECECEC;
      border-bottom: 2px solid #ECECEC;
      border-radius: 2px;
      margin: 0px 0 8px 0;
      padding: 4px 4px 0 4px;
      height: 20px;
      max-width: 100%;
      text-overflow: ellipsis;
      position: relative;
      white-space: pre;
      transition: transform 0.2s ease-out;

      &:not(.bk-edited-node):hover:after {
        display: block;
      }

      &.bk-edited-node {
        background-color: inherit;
        color: #4e515e;
      }

      &:hover {
        background-color: inherit;
        transition: background 0.1s ease-out;
      }

      &.removed {
        max-width: 0;
        transform: scale(0);
        transition: transform 0.2s ease-out, max-width 0.2s ease-out 0.2s;
      }

      // This is the remove button.
      &:after {
        display: none;
        position: absolute;
        width: 14px;
        height: 14px;
        text-align: center;
        font-size: 14px;
        font-weight: 900;
        top: -8px;
        right: -3px;
        content: "\00d7";
        border-radius: 10px;
        cursor: pointer;
        background: #616161;
        z-index: 1;
        line-height: 12px;
        color: #fff;
      }
    }

    .token-type-a {
      background-color: #e7f4ff;
      border-bottom: 2px solid #85C8FF;
    }

    .token-type-b {
      background: #FFF3D0;
      border-bottom: 2px solid #FFF3D0;
    }

    .incomplete-token {
      background-color: #FFD6CE;
      border-bottom: 2px solid #FFD6CE;

      margin-right: 8px;
      padding-left: 4px;
      padding-right: 4px;

      &.bk-edited-node {
        margin-left: 0;
        border-bottom: 2px dotted #BFBFBF;
      }
    }


  }

  .result.count {
    display: none;
  }


  .loading-container-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(255, 255, 255, .7);
  }

  .search-result-group {
    .loading-container-overlay {
      left: -15px;
      right: -15px;
      width: auto;
    }
  }

  /* Fixing Safari Bug wrong column wrapping */
  @media (min-width: 768px) {
    .categories-selection .col-sm-8 .flex-row {
      flex-wrap: nowrap;
    }
  }

  .taglist,
  .file-categories {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: inline-block;
      }

      .badge {
        font-size: 12px;
        border: 1px solid #ccc;
        padding: 2px 4px;
        margin-right: 4px;

        &.selected {
          border-color: #3278be;
        }

      }


    }
  }


  .dropdown-list {
    position: relative;
    top: 36px;
    left: -13px;

    .dropdown-wrapper {
      position: absolute;
      background-color: #fff;
      border: 1px solid #cccccc;;
      box-shadow: 0 5px 15px 0px rgba(0, 0, 0, .15);
      border-top: 1px solid transparent;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        padding: 6px 15px;
        border-bottom: 1px solid #eeeeee;
        min-width: 300px;
        cursor: pointer;
        font-size: 14px;

        &.selected {
          background-color: rgb(231, 242, 247);
        }

        &:hover, &.current {
          background-color: rgb(50, 120, 190);
          color: #fff;
          box-shadow: 0 0px 15px 0px rgba(50, 120, 190, .4);
        }


      }
    }
  }



  .checkbox-menu {
    width: 100%;
  }

  .checkbox-menu li label {
    display: block;
    text-align: left;
    padding: 3px 10px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    margin: 0;
    transition: background-color .4s ease;
  }

  .checkbox-menu li input {
    margin: 0px 5px;
    top: 2px;
    position: relative;
  }

  .checkbox-menu li.active label {
    background-color: #cbcbff;
    font-weight: bold;
  }

  .checkbox-menu li label:hover,
  .checkbox-menu li label:focus {
    background-color: #f5f5f5;
  }

  .checkbox-menu li.active label:hover,
  .checkbox-menu li.active label:focus {
    background-color: #b8b8ff;
  }

  .input-group-select {
    position: relative;
    width: 20%;
    display: table-cell;

    .btn {
      text-align: left;
    }
  }

  .vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
  }

  .vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0, 0, 0, 0);
    transform: rotate3d(0, 0, 0, 0);
    -webkit-transition: background-color 100ms ease-out,
    margin 100ms ease-out,
    height 100ms ease-out;
    transition: background-color 100ms ease-out,
    margin 100ms ease-out,
    height 100ms ease-out;
    background-color: rgba(48, 121, 244, .1);
    margin: 5px 5px 5px 0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
  }

  .vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .3);
  }

  .vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
    margin: 0px;
    height: 100%;
  }

  .vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(48, 121, 244, .5);
  }


  .tokenizer {
    position: relative;
    display: flex;
    flex-direction: row;
    flex: 1 1 0px;
    min-width: 0px;
    flex-wrap: wrap;
    align-items: flex-start;
    align-self: flex-start;
    min-height: 32px;
    padding: 8px 5px 0 5px;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
    font-family: Regular, helvetica neue, helvetica, Arial, sans-serif;
    border-radius: 3px;
    border-right: none;
    color: #4e515e;
    overflow: hidden;
    word-wrap: break-word;

    .no-animation {
      transition: none !important;
    }

    .separator {
      display: inline-block;
      height: 24px;
      padding: 8px 4px 0px 4px;
      margin: -4px 0 0px 0;
      transition: transform 0.2s ease-out;
      cursor: text;
      border-bottom: 2px solid transparent;

      &:not(.bk-edited-node):hover {
        //background-image: url(../resources/img/fill-dots-gray5.png);
      }

      &.bk-edited-node {
        height: 20px;
        transform: translate3d(8px, 0, 0);
        transition: transform 0.2s ease-in;
      }

      &.bk-edited-node ~ .token {
        transform: translate3d(16px, 0, 0);
        transition: transform 0.2s ease-in;
      }


      &.bk-edited-node ~ .separator {
        transform: translate3d(16px, 0, 0);
        transition: transform 0.2s ease-in;
      }

      &.bk-edited-node:not(:empty) {
        border-bottom: 2px dotted #BFBFBF;
        border-radius: 2px;
      }
    }

    .init-token {
      position: relative;
      background-color: transparent;
      padding-left: 4px;
      padding-right: 4px;
      padding-top: 4px;

      &:hover {
        border-bottom: inherit;
      }

      &:not(:empty) {
        border-bottom: 2px dotted #333333;
      }
    }

    .token {
      display: inline-block;
      background-color: #ECECEC;
      border-bottom: 2px solid #ECECEC;
      border-radius: 2px;
      margin: 0px 0 8px 0;
      padding: 4px 4px 0 4px;
      height: 20px;
      max-width: 100%;
      text-overflow: ellipsis;
      position: relative;
      white-space: pre;
      transition: transform 0.2s ease-out;

      &:not(.bk-edited-node):hover:after {
        display: block;
      }

      &.bk-edited-node {
        background-color: inherit;
        color: #4e515e;
      }

      &:hover {
        background-color: inherit;
        transition: background 0.1s ease-out;
      }

      &.removed {
        max-width: 0;
        transform: scale(0);
        transition: transform 0.2s ease-out, max-width 0.2s ease-out 0.2s;
      }

      // This is the remove button.
      &:after {
        display: none;
        position: absolute;
        width: 14px;
        height: 14px;
        text-align: center;
        font-size: 14px;
        font-weight: 900;
        top: -8px;
        right: -3px;
        content: "\00d7";
        border-radius: 10px;
        cursor: pointer;
        background: #616161;
        z-index: 1;
        line-height: 12px;
        color: #fff;
      }
    }

    .token-type-a {
      background-color: #e7f4ff;
      border-bottom: 2px solid #85C8FF;
    }

    .token-type-b {
      background: #FFF3D0;
      border-bottom: 2px solid #FFF3D0;
    }

    .incomplete-token {
      background-color: #FFD6CE;
      border-bottom: 2px solid #FFD6CE;

      margin-right: 8px;
      padding-left: 4px;
      padding-right: 4px;

      &.bk-edited-node {
        margin-left: 0;
        border-bottom: 2px dotted #BFBFBF;
      }
    }
  }


  .filtered-search-box .form-control, .filtered-search-box .search form, .search .filtered-search-box form {
    position: relative;
    min-width: 200px;
    padding-right: 25px;
    padding-left: 0;
    height: 34px;
    line-height: inherit;
    border-color: transparent;
  }

  .form-control, .search form {
    border-radius: 2px;
    padding: 6px 10px;
  }

  .filtered-search-box-input-container {
    flex: 1;
    position: relative;
    min-width: 0;
    padding: 0;
  }

  .filtered-search-wrapper .tokens-container {
    display: -webkit-flex;
    display: flex;
    flex: 1;
    -webkit-flex: 1;
    padding-left: 12px;
    position: relative;
    margin-bottom: 0;
  }

  .filtered-search-token, .filtered-search-term {
    display: -webkit-flex;
    display: flex;
    flex-shrink: 0;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .filtered-search-token .selectable, .filtered-search-term .selectable {
    display: -webkit-flex;
    display: flex;
  }

  button, html [type="button"], [type="reset"], [type="submit"], [role="button"] {
    -webkit-appearance: inherit;
    cursor: pointer;
  }

  .filtered-search-token .name, .filtered-search-term .name {
    background-color: #f8f8f8;
    color: rgba(0, 0, 0, 0.55);
    border-radius: 2px 0 0 2px;
    margin-right: 1px;
    text-transform: capitalize;
  }

  .filtered-search-token .name, .filtered-search-token .value, .filtered-search-term .name, .filtered-search-term .value {
    display: inline-block;
    padding: 2px 7px;
  }

  .filtered-search-token .value-container, .filtered-search-term .value-container {
    background-color: #f0f0f0;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 0 2px 2px 0;
    margin-right: 5px;
    padding-right: 8px;
  }

  .filtered-search-token .value, .filtered-search-term .value {
    padding-right: 0;
  }

  .filtered-search-token .name, .filtered-search-token .value, .filtered-search-term .name, .filtered-search-term .value {
    display: inline-block;
    padding: 2px 7px;
  }

  .filtered-search-token .value img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }

  .filtered-search-token .remove-token, .filtered-search-term .remove-token {
    display: inline-block;
    padding-left: 4px;
    padding-right: 0;
  }

  .input-token {
    flex-basis: 100%;

    input {
      border: 0;
      height: 36px;

      &:focus {
        box-shadow: none;

      }
    }
  }

  .dropdown-document-result {
    display: flex;

    .result-thumbnail{
      &.no-thumbnail{
        width: 32px;
      }
    }

  }

  .left {
    flex-basis: 20%;
    max-width: 50px;
  }

  .right {
    flex-basis: 80%;
  }

  figure {
    height: 50px;
  }

  figure img {
    max-width: 100%;
    max-height: 100%;
  }

  p {
    color: inherit;
    font-size: 12px;
  }

</style>
